import { checkMobile } from "./fjk.mobile";
import { deviceWidth } from "./device.js";

export function mainNavSubmenu(){
    const nav = $(".header__nav__list");
    // console.log(checkMobile().device_type)
    // let device_type; 
    $(window).on("load resize", function () {
      let device_type = checkMobile().device_type;

      if (device_type === "desktop") {
        nav.find(".hasSublist").on("mouseover", function () {
          // console.log("over");
          $(this).find(".sublist").css("display", "block");
        });
        nav.find(".hasSublist").on("mouseout", function () {
          // console.log("out");
          $(this).find(".sublist").css("display", "none");
        });
      }
    });


    // mobile 時にサブナビがある場合はサブナビを作る

    function hasSublistItemAction(){
      
      $(".hasSublist > a").on("click",function(){
        if(deviceWidth().width < 768){
          $(this).removeAttr("href");
        }

        $(this).parent().toggleClass("sublist_open")
      })
    }


    function getSublist(selector){
      const sublist = $(selector);

      let result = []

      for (let i = 0; i < sublist.length; i++) {
        const elm = sublist[i];
        let item = {
          url: $(elm).find("a").attr("href"),
          label: $(elm).find(".ja").text(),
        };
        result.push(item);
      }
      // console.log(result)
      return result;
    }

    function createList(array,object){

      let list_html = `<ul class="mobile_nav_sublist">`;
      if(object){
        array.unshift(object)
      }
      for (let i = 0; i < array.length; i++) {
        const elm = array[i];
        
        list_html += `<li class="mobile_nav_sublist__item"><a href="${elm.url}">${elm.label}</a></li>`;
      }
      list_html += "</ul>"

      const result = list_html;
      // console.log(result)
      return result
    }

    
    let sublist_company = getSublist(
      ".sublist__company .sublist__wrapper .sublist__item"
    );
    let sublist_recruit = getSublist(
      ".sublist__recruit .sublist__wrapper .sublist__item"
    );
    let recruit_addtional_array = {
      url: "/recruit/",
      label: "採用情報トップ"
    }

    let sublist_company_html = createList(sublist_company);
    let sublist_recruit_html = createList(
      sublist_recruit
    );
    


    hasSublistItemAction();
    $(".hasSublist__company").append(sublist_company_html);
    $(".hasSublist__recruit").append(sublist_recruit_html);

}